export default __webpack_public_path__ + "media/images/burger-62c8a76d2d1f61188b3cf290abdb58b4.svg";